import Column from '@components/Column';

import Categories from './components/Categories';
import Contents from './components/Contents';

function GiftCategoryFragment() {
    return (
        <Column fullWidth>
            <Categories/>
            <Contents/>
        </Column>
    );
}

export default GiftCategoryFragment;
